import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import styled from '@xstyled/styled-components';
import { Space } from 'antd';
import { MathEnabledTextComponent, styleVariables } from '@lib/common';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var Layout = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 32px 24px;\n  border-radius: 12px;\n  box-shadow: 0px 3px 6px ", ";\n  overflow: hidden;\n"])), styleVariables.colors.transparentGray6);
var StyledContentWrapper = styled(Space)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  &.last-content {\n    margin-bottom: 0;\n  }\n"])));
var StyledQuestionTitle = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n"])), styleVariables.colors.gray13);
var StyledQuestionHeaderContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var StyledLeftCol = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-end;\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n"])));
var StyledQuestionContentTitle = styled(MathEnabledTextComponent)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n\n  color: ", ";\n"])), styleVariables.colors.gray13);
var StyledQuestionHeaderScore = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  margin-left: 8px;\n  color: ", ";\n"])), styleVariables.colors.gray10);
export var PinnedQuestionComponent = function PinnedQuestionComponent(_ref) {
  var question = _ref.question,
      label = _ref.label,
      hideScore = _ref.hideScore;
  return /*#__PURE__*/_jsxs(Layout, {
    direction: "vertical",
    size: "middle",
    className: "question-content",
    children: [/*#__PURE__*/_jsx(StyledQuestionHeaderContainer, {
      children: /*#__PURE__*/_jsxs(StyledLeftCol, {
        children: [/*#__PURE__*/_jsxs(StyledQuestionTitle, {
          children: [label.questionNumber, " ", question.titleIndex]
        }), !hideScore && /*#__PURE__*/_jsxs(StyledQuestionHeaderScore, {
          children: [question.score, " ", label.score]
        })]
      })
    }), /*#__PURE__*/_jsx(StyledContentWrapper, {
      direction: "vertical",
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(StyledQuestionContentTitle, {
          value: question.description
        })
      })
    })]
  });
};